var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5656 11.4188L20.25 12.5719L17.25 6.83438L19.5938 5.66251C19.7679 5.57372 19.9701 5.55741 20.1563 5.61712C20.3425 5.67683 20.4975 5.80772 20.5875 5.98126L22.8937 10.3969C22.9405 10.4853 22.9691 10.5821 22.9779 10.6817C22.9867 10.7813 22.9755 10.8817 22.9449 10.9769C22.9143 11.0721 22.865 11.1603 22.7999 11.2362C22.7348 11.312 22.6551 11.3741 22.5656 11.4188V11.4188Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74984 12.4781L1.43422 11.3156C1.34506 11.2719 1.26559 11.2107 1.20055 11.1357C1.13551 11.0607 1.08622 10.9734 1.05561 10.8789C1.02499 10.7844 1.01369 10.6848 1.02236 10.5859C1.03103 10.487 1.05951 10.3908 1.10609 10.3031L3.41234 5.88749C3.50256 5.71408 3.65691 5.58275 3.84253 5.52146C4.02814 5.46017 4.23035 5.47377 4.40609 5.55937L6.74984 6.73124L3.74984 12.4781Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.5719L18.75 14.3344L15.3 17.7844C15.206 17.8723 15.092 17.9362 14.968 17.9704C14.8439 18.0047 14.7133 18.0085 14.5875 17.9813L9.15 16.6219C9.05067 16.5942 8.95812 16.5463 8.87812 16.4813L3.75 12.4781",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7506 14.3344L14.6256 11.3344L13.4256 12.2344C12.9057 12.6224 12.2743 12.832 11.6256 12.832C10.9768 12.832 10.3455 12.6224 9.82557 12.2344L9.31932 11.85C9.23371 11.7849 9.16291 11.7024 9.11158 11.6079C9.06026 11.5134 9.0296 11.409 9.02162 11.3018C9.01365 11.1946 9.02854 11.0868 9.06531 10.9858C9.10209 10.8847 9.15991 10.7926 9.23495 10.7156L12.9099 7.04998C12.979 6.98129 13.0609 6.92688 13.151 6.88988C13.2411 6.85288 13.3376 6.83401 13.4349 6.83436H17.2506",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80664 6.73127L11.616 5.32502C11.7869 5.27601 11.9696 5.2893 12.1316 5.36252L15.3754 6.83439",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.9594L7.67813 19.2469C7.56313 19.2209 7.45666 19.166 7.36875 19.0875L5.25 17.25",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.5087c1d987a34f979da1a97b8dabbd90.svg";
export { ForwardRef as ReactComponent };